module.exports = __webpack_public_path__ + "static/media/menu_active_icon.2e03b1c9.svg";